import { Divider } from "components/atoms/Divider";
import { FC } from "react";
import Grid from "shared/components/atoms/grid";
import { styled } from "twin.macro";

const Semi = styled.div<{ reverse?: boolean }>`
  font-family: HiraMinProN-W6;
  font-size: 100px;
  color: #f3f7fd;
  letter-spacing: 2.94px;
  line-height: 0px;
  position: relative;
  ${({ reverse }) =>
    reverse
      ? `
    transform: scaleX(-1) scaleY(-1);
    top: -8px;
    left: -8px;
  `
      : `
    transform: scaleY(-1);
    bottom: 8px;
    right: -8px;
  `}
`;

const Deco = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 16px 0;
`;

export const Quote: FC = ({ children }) => {
  return (
    <Grid fullWidth>
      <Deco>
        <Semi reverse>”</Semi>
        <Divider tw="w-3/4 bg-[#F3F7FD]" />
      </Deco>
      {children}
      <Deco>
        <Divider tw="w-3/4 bg-[#F3F7FD]" />
        <Semi>”</Semi>
      </Deco>
    </Grid>
  );
};
